
import Messenger from "../../../assets/duotone/Messenger.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MessengerIcon({ className, dataTestid = "MessengerIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Messenger data-testid={dataTestid} className={classes} {...rest} />
  );
}
